import { useParams } from "react-router-dom-v5-compat";
import { useGetShopQueryParams } from "../../../hooks";

export const useShopPageRoute = () => {
  const queryParams = useGetShopQueryParams();

  const { lodgingId } = useParams();

  if (lodgingId == null) {
    throw new Error("LodgingId is missing");
  }

  return {
    ...queryParams,
    lodgingId,
  };
};
